
export const sessiontext = {
    id: "Id",
    name: "Nom",
    handlerid: "Energy Box",
    type: "Type",
    group: "Entité",
    watchperiod: "Fréquence de lecture",
    laststatustime: "Date de dernier statut",
    laststatus: "Dernier statut",
    rooturl: "URL racine",
    sessionurl: "URL de session",
    nosession: "Aucune session à afficher",
    sessionedition: "Modification d'une session",
    equipmentcount: "Nombre d'équipements",
    sessiondel: "Suppression de la session",
    sessiondelconfirm: "Êtes-vous sûr de vouloir supprimer la session",
    sessiondelok: "La session a été supprimée",
}
